import { FC } from "react";
import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableComponent from "./center-tables/order-optimizer-taxi-details-hidden-details-center-tables.component";
import OrderOptimizerTaxiDetailsHiddenDetailsDriverSelectComponent from "./driver/order-optimizer-taxi-details-hidden-details-driver-select.component";
import OrderOptimizerTaxiDetailsHiddenDetailsDriver from "./driver/types/order-optimizer-taxi-details-hidden-details-driver";
import OrderOptimizerTaxiDetailsHiddenDetailsSummaryFooterComponent from "./summary-footer/order-optimizer-taxi-details-hidden-details-summary-footer.component";
import OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableComponent from "./heading-tables/order/order-optimizer-taxi-details-hidden-details-heading-tables-order-table.component";
import OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableComponent from "./heading-tables/driver/order-optimizer-taxi-details-hidden-details-heading-tables-driver-table.component";
import OrderOptimizerTaxiDetailsItem from "../common/types/order-optimizer-taxi-details-item";

type OrderOptimizerTaxiDetailsHiddenDetailsProps = {
  optimizationId: string | undefined;
  detailsItem: OrderOptimizerTaxiDetailsItem;
  onPotentialDriverChange: (
    driver: OrderOptimizerTaxiDetailsHiddenDetailsDriver | null
  ) => void;
};

const OrderOptimizerTaxiDetailsHiddenDetailsComponent: FC<
  OrderOptimizerTaxiDetailsHiddenDetailsProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getTaxiDetailsTranslations();

  return (
    <>
      <div className="order_optimizer_taxi_details_hidden_details">
        <div className="order_optimizer_taxi_details_hidden_details__heading_section">
          <div className="order_optimizer_taxi_details_hidden_details__heading_section__left">
            <div>
              <OrderOptimizerTaxiDetailsHiddenDetailsDriverSelectComponent
                optimizationId={props.optimizationId}
                onPotentialDriverChange={props.onPotentialDriverChange}
              />
            </div>
          </div>
          <div className="order_optimizer_taxi_details_hidden_details__heading_section__center">
            <h4 className="order_optimizer_taxi_details_hidden_details_order__text">
              {translations.table.headingTables.headingOrdersLabel}
            </h4>
            <div className="order_optimizer_taxi_details_hidden_details_order">
              <OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableComponent
                detailsStepsHomeToStartItems={
                  props.detailsItem.steps.homeToStart
                }
              />
            </div>
          </div>
          <div className="order_optimizer_taxi_details_hidden_details__heading_section__right">
            <h4 className="order_optimizer_taxi_details_hidden_details_order__text">
              {translations.table.headingTables.headingDrierLabel}
            </h4>
            <div className="order_optimizer_taxi_details_hidden_details_driver">
              <OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableComponent
                detailsStepsHomeToStartItem={
                  props.detailsItem.steps.homeToStart
                }
              />
            </div>
          </div>
        </div>
        <div className="order_optimizer_taxi_details_hidden_details__center_section">
          <OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableComponent
            orders={props.detailsItem.orders}
            ordersSteps={props.detailsItem.steps.orders}
            driver={props.detailsItem.driver}
          />
        </div>
        <div className="order_optimizer_taxi_details_hidden_details__lower_section">
          <OrderOptimizerTaxiDetailsHiddenDetailsSummaryFooterComponent
            detailsItem={props.detailsItem}
          />
        </div>
      </div>
    </>
  );
};

export default OrderOptimizerTaxiDetailsHiddenDetailsComponent;
